module.exports = __webpack_public_path__ + "static/media/announcement.53ec273e.svg";